import { useState, useEffect } from "react";
import { Col, Modal, Row, Button, Checkbox } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { fetchSidebarLab } from "../../../login/redux/actions";
import CheckboxComponent from "./checkbox";
import { getLSKey, LS_KEYS } from "../../../../utils/localStorageHelper";

const SelectLabsPopup = ({
  visible,
  setVisible,
  setSelectedLabs,
  selectedLabs,
}) => {
  const [filteredLabs, setFilteredLabs] = useState([]);
  const [showAll, setShowAll] = useState(false);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [list, setList] = useState([]);

  const dispatch = useDispatch();
  const { labs, user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    const filtered = (labs || []).filter(
      (el) => el?.labSetup?.labStatus?.showByDefault === true
    );
    setFilteredLabs(filtered);

    if (filtered.length === 0 && (labs || []).length > 0) {
      setList(labs || []);
      setShowAll(true);
    } else {
      setList(filtered);
    }
  }, [labs]);

  useEffect(() => {
    if (isCheck.length > 0 && isCheck.length === list.length) {
      setIsCheckAll(true);
    } else {
      setIsCheckAll(false);
    }
  }, [isCheck, list]);

  useEffect(() => {
    if (user?.id) {
      let ls = localStorage.getItem(getLSKey(LS_KEYS.SELECTED_LABS, user.id));
      if (ls !== null) {
        setSelectedLabs(JSON.parse(ls));
        setTimeout(() => {
          getFromLocalStorage(user.id);
        }, 2000);
      }
    }
  }, [user?.id]);

  useEffect(() => {
    // getFromLocalStorage();
  }, [selectedLabs]);

  const handleSelectAll = (e) => {
    const newIsCheckAll = !isCheckAll;
    setIsCheckAll(newIsCheckAll);

    if (newIsCheckAll) {
      // If we're checking "Select All", add all items
      setIsCheck(list.map((li) => li.labSetup?.id || li.id));
    } else {
      // If we're unchecking "Select All", clear the selection
      setIsCheck([]);
    }
  };

  const handleClick = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };

  const handleShowAll = (e) => {
    const { checked } = e.target;
    setShowAll(checked);

    let updatedList = checked ? (labs || []) : filteredLabs;
    setList(updatedList);

    // setIsCheck([...isCheck, id]);
    // if (!checked) {
    //   setIsCheck(isCheck.filter((item) => item !== id));
    // }
  };

  useEffect(() => {
    if (user?.id) {
      dispatch(fetchSidebarLab({ userId: user.id }));
    }
  }, [visible, user?.id]);

  const handleOk = () => { };

  const handleCancel = () => {
    setVisible(false);
  };

  const setToLocalStorage = (selectedLabs) => {
    if (!user?.id) return;
    localStorage.setItem(
      getLSKey(LS_KEYS.SELECTED_LABS, user.id),
      JSON.stringify(selectedLabs)
    );
    localStorage.setItem(
      getLSKey(LS_KEYS.FILTERED_LABS, user.id),
      JSON.stringify(filteredLabs)
    );

    localStorage.setItem(getLSKey(LS_KEYS.IS_CHECK, user.id), JSON.stringify(isCheck));
    localStorage.setItem(getLSKey(LS_KEYS.LIST, user.id), JSON.stringify(list));
  };

  const getFromLocalStorage = (userId) => {
    const id = userId || user?.id;
    if (!id) return;
    
    setFilteredLabs(
      JSON.parse(localStorage.getItem(getLSKey(LS_KEYS.FILTERED_LABS, id))) || []
    );
    setIsCheck(JSON.parse(localStorage.getItem(getLSKey(LS_KEYS.IS_CHECK, id))) || []);
    setList(JSON?.parse(localStorage.getItem(getLSKey(LS_KEYS.LIST, id))) || []);
  };

  const handleApplyBtn = () => {
    let selectedLabs = (labs || []).filter((el) => isCheck.includes(el.labSetup.id));
    setSelectedLabs(selectedLabs);
    setVisible(false);
    setToLocalStorage(selectedLabs);
  };

  const ModalBody = () => {
    const catalog = list.map((el) => {
      const { id, labNumber, labName } = el.labSetup || {};
      let name = `${labName || ''}`;

      if (!id) return null;
      return (
        <div key={id} className="checkbox-col-lab">
          <CheckboxComponent
            name={name}
            id={id}
            handleClick={handleClick}
            isChecked={isCheck.includes(id)}
          />
          <span>{name}</span>
        </div>
      );
    });

    return (
      <div className="checkbox-parent-div">
        {catalog}
      </div>
    );
  };

  const Footer = () => {
    return (
      <Row justify="center" gutter={[20, 0]}>
        <Col>
          <Button className="apply-btn" size="small" onClick={handleApplyBtn}>
            Apply
          </Button>
        </Col>
        <Col>
          <Button className="cancel-btn" size="small" onClick={handleCancel}>
            Cancel
          </Button>
        </Col>
      </Row>
    );
  };

  const Title = () => {
    return (
      <Row>
        <Col span={24}>
          <Row justify="start" gutter={[20, 0]} className="header-row">
            <Col span={12}>
              <div className="checkbox-div-lab">
                <Checkbox
                  name="selectAll"
                  id="selectAll"
                  onChange={handleSelectAll}
                  checked={isCheckAll}
                />
                <span>Select All</span>
              </div>
            </Col>
            <Col>
              <div className="checkbox-div-lab">
                <Checkbox
                  id="showAll"
                  name="showAll"
                  onChange={handleShowAll}
                  checked={showAll}
                />
                <span>Show All Labs</span>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <>
      <Modal
        className="select-labs-modal"
        title={<Title />}
        visible={visible}
        width={393}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={<Footer />}
        closeIcon={<></>}
      >
        <ModalBody />
      </Modal>
    </>
  );
};

export default SelectLabsPopup;
